import React, { useContext, useEffect, useState } from "react"
import { useTranslation } from "react-i18next"
import Select , { components } from "react-select"

import downIcon from "../../assets/Hub_Icons/downchevron.svg"
import { GlobalContext } from "../../context/GlobalContext"


const DropdownIndicator=(props)=>{
    return(
        <components.DropdownIndicator { ...props }>
            <img alt="dropdown"
                src={ downIcon }
                className=""
                height={ "16px" }
                width={ "16px" }
            />
        </components.DropdownIndicator>
    )
}
const customeStylesTemp = (isSelected) =>{
    const customeStyles={
        input:styles => ({ ...styles, fontSize:"14px", lineHeight:"20px", color:"#34383F" }),
        indicatorSeparator:styles => ({ ...styles, display:"none" }),
        option:() => ({    
            color: "#34383F",
            fontSize: "14px",
            lineHeight: "20px",
            backgroundColor: "white",
            padding: "7px 12px",
            cursor: "default",
            "&:hover": {
                backgroundColor: "#F8F9FA"
            }
        }),
        control:(provided , state) => ({ 
            ...provided,   
            borderColor: state.isFocused ? "#003DA5" : "#CED0D6",  
            backgroundColor: 
        state.selectProps.menuIsOpen
            ? "#EDF5FF"
            : "#FFFFFF",
            borderRadius:"8px",
            boxShadow: state.isFocused && "none",
            "&:hover": {
                borderColor: "#003DA5"
            }
    
        }),
        menu:(provided) => ({
            ...provided,
            maxHeight:"260px",
            paddiing:"0",
            borderColor:"#E2E3E5",
            borderRadius:"8px",
            borderWidth:"1px"
        }),
        menuList: (provided) => ({
            ...provided,
            maxHeight: "260px",
            overflow: "scroll"
        })
    }
    return customeStyles
}


const LanguageSelector = ({
    setCurrentLanguages,
    isDisabled=false,
    excludedFeild,
    currentVal,
    indexValue
}) => {
    const { languages } = useContext(GlobalContext)
    useTranslation()
    const [isSelected, setIsSelected] = useState(false)
    const convertLanguagesResponse = languages && languages
        .filter((e)=>excludedFeild !== e.id)
        .map((e)=>{
            return {
                value:e.id,
                label:`${e.code} - ${e.name}`
            }
        }).sort((a,b) => {
            if (a.label === b.label) {
                return 0
            }
            return a.label > b.label ? 1 : -1
        })
 
    const hanleChange = (selectedOption) => {    
        if(selectedOption.label!=""){
            setIsSelected(true)
        }
        if(indexValue){
            setCurrentLanguages(selectedOption.value, indexValue) 
        }else{
            setCurrentLanguages(selectedOption.value) 
        }    
    }
    const currentEditSelected = currentVal &&  languages?.filter((e)=>e.id == currentVal)[0]

    const [defaultVal, setDefaultVal] = useState({
        value: 12,
        label: "EN - English"
    })

    useEffect(()=>{
        const defVal = currentVal? {
            value:currentEditSelected?.id,
            label:`${currentEditSelected?.code} - ${currentEditSelected?.name}`
        } : convertLanguagesResponse[0]
        setDefaultVal(defVal)
    },[currentEditSelected])

    return (
        <div>
            <Select
                options={ convertLanguagesResponse }
                styles={ customeStylesTemp(isSelected) }
                defaultValue={ defaultVal }
                components={ { DropdownIndicator } }
                classNamePrefix="select"
                onChange={ hanleChange }
                isDisabled={ isDisabled }
            />
        </div>
    )
}

export default LanguageSelector
